
import { notification } from "antd";
import instance from "api/cmsapi";
import { useMutation, useQuery, useQueryClient } from "react-query";


 
// CREATE
const createRCCAssessment = async (payload) => {
  const { data } = await instance.post(`rcc-assessments`, payload);
  return data;
};
 
// UPDATE
const updateRCCAssessment = async ({ id, payload }) => {
  const { data } = await instance.put(
    `rcc-assessments/${id}`,
    payload
  );
  return data;
};
 
// GET ALL
const getAllRCCAssessments = async () => {
  const { data } = await instance.get(`rcc-assessments`);
  return data;
};
 
// GET BY ID
const getRCCAssessmentById = async (id) => {
  const { data } = await instance.get(
    `rcc-assessments/${id}`
  );
  return data;
};
 
// GET BY DISTRICT + SETUP
const getRCCAssessmentByDistrict = async (params) => {
  const { districtCode, assessmentSetupId } = params;
 
  const { data } = await instance.get(
    `rcc-assessments/district`,
    {
      params: {
        districtCode,
        assessmentSetupId,
      },
    }
  );
 
  return data;
};
 
// GET BY REGION + YEAR + QUARTER
const getRCCAssessmentByRegion = async (params) => {
  const { regionCode, year, quarter } = params;
 
  const { data } = await instance.get(
    `rcc-assessments/region/${regionCode}/${year}/${quarter}`
  );
 
  return data;
};
 
 
// ==========================
// REACT QUERY HOOKS
// ==========================
 
// GET BY REGION
export function useGetRCCAssessmentByRegion(params) {
  return useQuery(
    ["getRCCAssessmentByRegion", params],
    () => getRCCAssessmentByRegion(params),
    {
      enabled: !!params?.regionCode && !!params?.year && !!params?.quarter,
      onError: (error) =>
        notification.error({
          message:
            error?.response?.data?.message ||
            "Error fetching RCC assessments by region",
        }),
    }
  );
}
 
// GET BY DISTRICT
export function useGetRCCAssessmentByDistrict(params) {
  return useQuery(
    ["getRCCAssessmentByDistrict", params],
    () => getRCCAssessmentByDistrict(params),
    {
      enabled: !!params?.districtCode && !!params?.assessmentSetupId,
      onError: (error) =>
        notification.error({
          message:
            error?.response?.data?.message ||
            "Error fetching RCC assessment",
        }),
    }
  );
}
 
// GET ALL
export function useGetAllRCCAssessments() {
  return useQuery(
    ["getAllRCCAssessments"],
    getAllRCCAssessments,
    {
      onError: (error) =>
        notification.error({
          message:
            error?.response?.data?.message ||
            "Error fetching all RCC assessments",
        }),
    }
  );
}
 
// GET BY ID
export function useGetRCCAssessmentById(id) {
  return useQuery(
    ["getRCCAssessmentById", id],
    () => getRCCAssessmentById(id),
    {
      enabled: !!id,
      onError: (error) =>
        notification.error({
          message:
            error?.response?.data?.message ||
            "Error fetching RCC assessment details",
        }),
    }
  );
}
 
// CREATE
export function useCreateRCCAssessment() {
  const queryClient = useQueryClient();
 
  return useMutation(createRCCAssessment, {
    onSuccess: () => {
      notification.success({
        message: "RCC Assessment created successfully",
      });
 
      queryClient.invalidateQueries(["getAllRCCAssessments"]);
      queryClient.invalidateQueries(["getRCCAssessmentByRegion"]);
      queryClient.invalidateQueries(["getRCCAssessmentByDistrict"]);
    },
    onError: (error) =>
      notification.error({
        message:
          error?.response?.data?.message ||
          "Error creating RCC assessment",
      }),
  });
}
 
// UPDATE
export function useUpdateRCCAssessment() {
  const queryClient = useQueryClient();
 
  return useMutation(updateRCCAssessment, {
    onSuccess: () => {
      notification.success({
        message: "RCC Assessment updated successfully",
      });
 
      queryClient.invalidateQueries(["getAllRCCAssessments"]);
      queryClient.invalidateQueries(["getRCCAssessmentByRegion"]);
      queryClient.invalidateQueries(["getRCCAssessmentByDistrict"]);
    },
    onError: (error) =>
      notification.error({
        message:
          error?.response?.data?.message ||
          "Error updating RCC assessment",
      }),
  });
}

// ==========================

// API ASSESSMENT FUNCTIONS

// ==========================
 
// CREATE

const createAssessment = async (payload) => {

  const { data } = await instance.post(

    `assessments`,

    payload

  );

  return data;

};
 
// UPDATE

const updateAssessment = async ({ id, payload }) => {

  const { data } = await instance.put(

    `assessments/${id}`,

    payload

  );

  return data;

};
 
// GET ALL

const getAllAssessments = async () => {

  const { data } = await instance.get(

    `assessments`

  );

  return data;

};
 
// GET BY DISTRICT + YEAR + TYPE

const getAssessmentByParams = async (params) => {

  const { districtId, year, type } = params;
 
  const { data } = await instance.get(

    `assessments/dpat/${districtId}/${year}/${type}`

  );
 
  return data;

};
 
 
// ==========================

// REACT QUERY HOOKS OF ASSESSMENT

// ==========================
 
// GET ALL

export function useGetAllAssessments() {

  return useQuery(

    ["getAllAssessments"],

    getAllAssessments,

    {

      onError: (error) =>

        notification.error({

          message:

            error?.response?.data?.message ||

            "Error fetching assessments",

        }),

    }

  );

}
 
// GET BY DISTRICT + YEAR + TYPE

export function useGetAssessmentByParams(params) {

  return useQuery(

    ["getAssessmentByParams", params],

    () => getAssessmentByParams(params),

    {

      enabled:

        !!params?.districtId &&

        !!params?.year &&

        !!params?.type,

      onError: (error) =>

        notification.error({

          message:

            error?.response?.data?.message ||

            "Error fetching assessment",

        }),

    }

  );

}
 
// CREATE

export function useCreateAssessment() {

  const queryClient = useQueryClient();
 
  return useMutation(createAssessment, {

    onSuccess: () => {

      notification.success({

        message: "Assessment created successfully",

      });
 
      queryClient.invalidateQueries(["getAllAssessments"]);

      queryClient.invalidateQueries(["getAssessmentByParams"]);

    },

    onError: (error) =>

      notification.error({

        message:

          error?.response?.data?.message ||

          "Error creating assessment",

      }),

  });

}
 
// UPDATE

export function useUpdateAssessment() {

  const queryClient = useQueryClient();
 
  return useMutation(updateAssessment, {

    onSuccess: () => {

      notification.success({

        message: "Assessment updated successfully",

      });
 
      queryClient.invalidateQueries(["getAllAssessments"]);

      queryClient.invalidateQueries(["getAssessmentByParams"]);

    },

    onError: (error) =>

      notification.error({

        message:

          error?.response?.data?.message ||

          "Error updating assessment",

      }),

  });

}
 

/* =========================================================

   API Requests RCC Assessment Summary

   ========================================================= */


// CREATE
export const createAssessmentSummary = async (payload) =>
  await instance.post("rcc-assessment-summaries", payload);

// UPDATE
export const updateAssessmentSummary = async ({ id, payload }) =>
  await instance.put(`rcc-assessment-summaries/${id}`, payload);

// GET ALL
export const getAllAssessmentSummaries = async () =>
  await instance.get("rcc-assessment-summaries");

// GET BY ID
export const getAssessmentSummaryById = async (id) =>
  await instance.get(`rcc-assessment-summaries/${id}`);

// GET BY DISTRICT
export const getAssessmentSummaryByDistrict = async ({
  districtCode,
  year,
  quarter,
}) =>
  await instance.get(
    `rcc-assessment-summaries/district?districtCode=${districtCode}&year=${year}&quarter=${quarter}`
  );

// GET BY REGION
export const getAssessmentSummaryByRegion = async ({
  regionCode,
  year,
  quarter,
}) =>
  await instance.get(
    `rcc-assessment-summaries/region/${regionCode}/${year}/${quarter}`
  );

/* =========================================================

   React Query Hooks RCC Assessment Summary

   ========================================================= */

// GET ALL
export function useGetAllAssessmentSummaries() {
  return useQuery(
    ["getAllAssessmentSummaries"],
    getAllAssessmentSummaries,
    {
      onError: (error) =>
        notification.error({
          message:
            error?.response?.data?.message ||
            "Error fetching RCC assessment summaries",
        }),
    }
  );
}

// GET BY ID
export function useGetAssessmentSummaryById(id) {
  return useQuery(
    ["getAssessmentSummaryById", id],
    () => getAssessmentSummaryById(id),
    {
      enabled: !!id,
      onError: (error) =>
        notification.error({
          message:
            error?.response?.data?.message ||
            "Error fetching assessment summary",
        }),
    }
  );
}

// GET BY DISTRICT
export function useGetAssessmentSummaryByDistrict(params) {
  return useQuery(
    ["getAssessmentSummaryByDistrict", params],
    () => getAssessmentSummaryByDistrict(params),
    {
      enabled:
        !!params?.districtCode && !!params?.year && !!params?.quarter,
      onError: (error) =>
        notification.error({
          message:
            error?.response?.data?.message ||
            "Error fetching district assessment summary",
        }),
    }
  );
}

// GET BY REGION
export function useGetAssessmentSummaryByRegion(params) {
  return useQuery(
    ["getAssessmentSummaryByRegion", params],
    () => getAssessmentSummaryByRegion(params),
    {
      enabled:
        !!params?.regionCode && !!params?.year && !!params?.quarter,
      onError: (error) =>
        notification.error({
          message:
            error?.response?.data?.message ||
            "Error fetching regional assessment summaries",
        }),
    }
  );
}

// CREATE
export function useCreateAssessmentSummary() {
  const queryClient = useQueryClient();

  return useMutation(createAssessmentSummary, {
    onSuccess: () => {
      notification.success({
        message: "Assessment summary created successfully",
      });

      queryClient.invalidateQueries(["getAllAssessmentSummaries"]);
      queryClient.invalidateQueries(["getAssessmentSummaryByDistrict"]);
      queryClient.invalidateQueries(["getAssessmentSummaryByRegion"]);
    },
    onError: (error) =>
      notification.error({
        message:
          error?.response?.data?.message ||
          "Error creating assessment summary",
      }),
  });
}

// UPDATE
export function useUpdateAssessmentSummary() {
  const queryClient = useQueryClient();

  return useMutation(updateAssessmentSummary, {
    onSuccess: () => {
      notification.success({
        message: "Assessment summary updated successfully",
      });

      queryClient.invalidateQueries(["getAllAssessmentSummaries"]);
      queryClient.invalidateQueries(["getAssessmentSummaryByDistrict"]);
      queryClient.invalidateQueries(["getAssessmentSummaryByRegion"]);
    },
    onError: (error) =>
      notification.error({
        message:
          error?.response?.data?.message ||
          "Error updating assessment summary",
      }),
  });
}

